import api from './api';

// Marketing Managers
export const fetchMarketingManagers = async (params = {}) => {
  const response = await api.get('/admin/marketing/managers/', { params });
  return response.data;
};

export const getMarketingManager = async (id) => {
  const response = await api.get(`/admin/marketing/managers/${id}/`);
  return response.data;
};

export const createMarketingManager = async (data) => {
  const response = await api.post('/admin/marketing/managers/', data);
  return response.data;
};

export const updateMarketingManager = async (id, data) => {
  const response = await api.put(`/admin/marketing/managers/${id}/`, data);
  return response.data;
};

export const patchMarketingManager = async (id, data) => {
  const response = await api.patch(`/admin/marketing/managers/${id}/`, data);
  return response.data;
};

export const deleteMarketingManager = async (id) => {
  const response = await api.delete(`/admin/marketing/managers/${id}/`);
  return response.data;
};

export const getManagerCustomers = async (id, params = {}) => {
  const response = await api.get(`/admin/marketing/managers/${id}/customers/`, { params });
  return response.data;
};

export const getManagerPerformance = async (id) => {
  const response = await api.get(`/admin/marketing/managers/${id}/performance/`);
  return response.data;
};

export const getManagerCommissions = async (id, params = {}) => {
  const response = await api.get(`/admin/marketing/managers/${id}/commissions/`, { params });
  return response.data;
};

// Customer Assignments
export const fetchCustomerAssignments = async (params = {}) => {
  const response = await api.get('/admin/marketing/assignments/', { params });
  return response.data;
};

export const fetchMyCustomerAssignments = async (params = {}) => {
  const response = await api.get('/admin/marketing/my-assignments/', { params });
  return response.data;
};

export const getCustomerAssignment = async (id) => {
  const response = await api.get(`/admin/marketing/assignments/${id}/`);
  return response.data;
};

export const createCustomerAssignment = async (data) => {
  const response = await api.post('/admin/marketing/assignments/', data);
  return response.data;
};

export const updateCustomerAssignment = async (id, data) => {
  const response = await api.put(`/admin/marketing/assignments/${id}/`, data);
  return response.data;
};

export const patchCustomerAssignment = async (id, data) => {
  const response = await api.patch(`/admin/marketing/assignments/${id}/`, data);
  return response.data;
};

export const deleteCustomerAssignment = async (id) => {
  const response = await api.delete(`/admin/marketing/assignments/${id}/`);
  return response.data;
};

export const reassignCustomer = async (id, data) => {
  const response = await api.post(`/admin/marketing/assignments/${id}/reassign/`, data);
  return response.data;
};

export const bulkReassignCustomers = async (data) => {
  const response = await api.post('/admin/marketing/assignments/bulk-reassign/', data);
  return response.data;
};

export const previewManualCustomerClaim = async (marketerQuery, customerQuery) => {
  const response = await api.get('/admin/marketing/assignments/', {
    params: {
      manual_claim: true,
      marketer_query: marketerQuery,
      customer_query: customerQuery,
    },
  });
  return response.data;
};

export const executeManualCustomerClaim = async (data) => {
  const response = await api.post('/admin/marketing/assignments/', {
    manual_claim: true,
    ...data,
  });
  return response.data;
};

// Commission Tiers
export const fetchCommissionTiers = async (params = {}) => {
  const response = await api.get('/admin/marketing/commission-tiers/', { params });
  return response.data;
};

export const getCommissionTier = async (id) => {
  const response = await api.get(`/admin/marketing/commission-tiers/${id}/`);
  return response.data;
};

// Manager Claim
export const searchClaimableCustomer = async (username) => {
  const response = await api.get('/admin/marketing/claim/', { params: { username } });
  return response.data;
};

export const claimCustomer = async (username) => {
  const response = await api.post('/admin/marketing/claim/', { username });
  return response.data;
};

export const createCommissionTier = async (data) => {
  const response = await api.post('/admin/marketing/commission-tiers/', data);
  return response.data;
};

export const updateCommissionTier = async (id, data) => {
  const response = await api.put(`/admin/marketing/commission-tiers/${id}/`, data);
  return response.data;
};

export const patchCommissionTier = async (id, data) => {
  const response = await api.patch(`/admin/marketing/commission-tiers/${id}/`, data);
  return response.data;
};

export const deleteCommissionTier = async (id) => {
  const response = await api.delete(`/admin/marketing/commission-tiers/${id}/`);
  return response.data;
};

// Commissions
export const fetchCommissions = async (params = {}) => {
  const response = await api.get('/admin/marketing/commissions/', { params });
  return response.data;
};

export const getCommission = async (id) => {
  const response = await api.get(`/admin/marketing/commissions/${id}/`);
  return response.data;
};

export const approveCommission = async (id) => {
  const response = await api.post(`/admin/marketing/commissions/${id}/approve/`);
  return response.data;
};

export const payCommission = async (id) => {
  const response = await api.post(`/admin/marketing/commissions/${id}/pay/`);
  return response.data;
};

export const getCommissionReport = async (params = {}) => {
  const response = await api.get('/admin/marketing/commissions/report/', { params });
  return response.data;
};

// Performance
export const fetchPerformance = async (params = {}) => {
  const response = await api.get('/admin/marketing/performance/', { params });
  return response.data;
};

export const getPerformance = async (id) => {
  const response = await api.get(`/admin/marketing/performance/${id}/`);
  return response.data;
};

// Attribution
export const fetchAttributionSummary = async (params = {}) => {
  const response = await api.get('/admin/marketing/attribution-summary/', { params });
  return response.data;
};

export const fetchMarketingEvents = async (params = {}) => {
  const response = await api.get('/admin/marketing/events/', { params });
  return response.data;
};

export const fetchMarketingTouchpoints = async (params = {}) => {
  const response = await api.get('/admin/marketing/touchpoints/', { params });
  return response.data;
};

export const fetchCustomerAttributionProfiles = async (params = {}) => {
  const response = await api.get('/admin/marketing/customers/', { params });
  return response.data;
};

export const fetchOrderAttributions = async (params = {}) => {
  const response = await api.get('/admin/marketing/orders/', { params });
  return response.data;
};

export const fetchAdProviderDeliveries = async (params = {}) => {
  const response = await api.get('/admin/marketing/provider-deliveries/', { params });
  return response.data;
};


export const fetchWebsiteAnalytics = async (params = {}) => {
  const response = await api.get('/admin/marketing/website-analytics/', { params });
  return response.data;
};
